export default function authReducer(state={}, action){
    switch(action.type){
        case 'SET_AUTH' :
            return {...state, data: action.payload}
        default: 
            return state
    }
}